import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Moon, Utensils, Zap } from "lucide-react";
import { SITE } from "@/constants/testIds";

const ICONS = {
    moon: Moon,
    utensils: Utensils,
    zap: Zap,
};

const PillarIcon = ({ name }) => {
    const Component = ICONS[name] || Zap;
    return <Component className="h-6 w-6 text-moss" strokeWidth={1.5} />;
};

export const HomePillarsSection = ({ pillars = [] }) => (
    <section data-testid={SITE.homePillars} className="py-14 sm:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl">
                <p className="font-accent text-xs text-terracotta">WHY AYURVEDA WORKS</p>
                <h2 className="mt-2 font-display text-3xl sm:text-4xl text-moss leading-tight">
                    The three pillars of wellness
                </h2>
                <p className="mt-3 text-foreground/75 leading-relaxed">
                    Ayurveda &mdash; the oldest continuously practiced system of medicine &mdash; names three things that uphold the entire architecture of health.
                </p>
            </div>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-5">
                {pillars.map((p, i) => (
                    <div
                        key={p.id}
                        data-testid={SITE.pillarCard}
                        className={`reveal reveal-delay-${i + 1} rounded-2xl border border-border/80 bg-white/80 p-6`}
                    >
                        <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sand text-moss">
                            <PillarIcon name={p.icon} />
                        </div>
                        <h3 className="mt-4 font-display text-xl text-moss">{p.name}</h3>
                        <p className="mt-2 text-sm text-foreground/75 leading-relaxed">
                            {p.summary}
                        </p>
                    </div>
                ))}
            </div>
            <div className="mt-8">
                <Link
                    to="/why-ayurveda"
                    className="inline-flex items-center gap-1.5 text-sm font-medium text-moss hover:text-terracotta"
                >
                    Learn more about doshas, elements &amp; pillars{" "}
                    <ArrowRight className="h-4 w-4" />
                </Link>
            </div>
        </div>
    </section>
);

export default HomePillarsSection;
